'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSparkles, iconSparklesTag } from '@ni/nimble-components/dist/esm/icons/sparkles';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSparkles };
export { iconSparklesTag };
export const NimbleIconSparkles = wrap(IconSparkles);